import { useMutation } from "@vue/apollo-composable";
import { LinkExternalAccountDocument } from "@/api/generated/graphql";

export async function linkExternalAccount() {
  const { onDone, onError, mutate } = useMutation(LinkExternalAccountDocument);
  const res = new Promise<{ consentUrl?: string | null }>((resolve, reject) => {
    onDone(result => resolve(result.data!.linkExternalAccount!));
    onError(error => reject(error));
  });
  await mutate();
  return res;
}
